// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"nj-z"};